import { Button, Card, CardBody, CardHeader, Spinner, Switch } from "@heroui/react"
import { EnvelopeOpenIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const GuardianInvitations = ({ handleSave, handleUpdate, isDirty, isLoading, isSaving, settings }) => (
  <Card className="mt-3">
    <CardHeader className="justify-between text-white bg-indigo-700">
      <div className="flex items-center">
        <EnvelopeOpenIcon className="mr-2 w-14 h-14" />
        
        <div className="flex flex-col">
          <h1 className="text-lg font-semibold">Guardian Invitations</h1>
          <p className="text-sm">
            What guardians should be invited to events.
          </p>
        </div>
      </div>

      <Button color="success" isDisabled={!isDirty || isLoading} isLoading={isSaving} className="font-semibold text-white" onPress={() => handleSave()}>Save</Button>
    </CardHeader>

    <CardBody>
      <p className="mb-4 text-content2-foreground">
        All primary guardians will be invited by default. Please use the filter below if you wish to limit the default selection.
      </p>

      <div className="px-4 pb-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Legal Guardians</h3>
            <p className="text-content2-foreground">Guardian must be a legal guardian.</p>
          </div>
          
          {isLoading && <Spinner className="ml-8" />}

          {!isLoading && (
            <Switch
              color="success"
              isSelected={settings.require_legal_guardian} 
              onValueChange={(value) => handleUpdate("require_legal_guardian", value)}
            />        
          )}
        </div>
      </div>
    </CardBody>
  </Card>
)

GuardianInvitations.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  settings: PropTypes.shape({
    require_legal_guardian: PropTypes.bool,
  }),
}

export default GuardianInvitations